"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkStrategy = function linkStrategy(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
  }, callback);
};

var Link = function Link(props) {
  var contentState = props.contentState,
      entityKey = props.entityKey,
      children = props.children;

  var _contentState$getEnti = contentState.getEntity(entityKey).getData(),
      url = _contentState$getEnti.url;

  return _react.default.createElement("a", {
    className: "link",
    href: url,
    rel: "noopener noreferrer",
    target: "_blank",
    title: url,
    "aria-label": url
  }, children);
};

Link.propTypes = {
  contentState: _propTypes.default.instanceOf(Object),
  entityKey: _propTypes.default.string,
  children: _propTypes.default.node
};
Link.defaultProps = {
  contentState: null,
  entityKey: null,
  children: null
};
var _default = {
  strategy: linkStrategy,
  component: Link
};
exports.default = _default;